<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">group</mat-icon>
				<span>Mitgliederverwaltung</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bLoading" />

			<button
				mat-raised-button
				color="primary"
				[disabled]="bLoading"
				[routerLink]="['Mitgliedererstellung']"
			>
				<span class="material-icons" style="vertical-align: text-top; margin-right: .5em">group_add</span>
				Neues Mitglied
			</button>

		</div>

		<div>

			@if( bLoading ) {
				<!-- spinner already in top bar -->
			}
			@else if( !elements.length ) {
				<div class="accNoElements">
					Kein Mitglied vorhanden
				</div>
			}
			@else {

				<div class="accFilterAndAccordeon">

					<mat-form-field
						appearance="outline"
						subscriptSizing="dynamic"
						class="accFilter"
					>

						<mat-label>Filter</mat-label>
						<input
							matInput
							placeholder="Beispiel: abc gmbh"
							(keyup)="onFilterChanged($event)"
						>
						<mat-icon matSuffix>search</mat-icon>

					</mat-form-field>

					<div class="accAccordeon">
	
						@if( !filteredElements.length ) {
	
							<div class="accNoElements">
								Keine Daten entspricht dem Filter
							</div>
	
						}	
						@else {

							<div
								class="accHeaders"
								[class.accSortIconDesc]="!sortingAsc"
							>
	
								<div
									class="accCell accActiveSorting"
									(click)="sortColumn('mitgliedsname')"
									title="Nach Mitgliedernamen sortieren"
								>
									<div class="accHeader">
										<span>Mitglieder</span>
										<mat-icon class="accSortIcon">
											{{ 'arrow_downward' }}
										</mat-icon>
									</div>
								</div>
	
							</div>
								
							<div class="accScrollPanel">
	
								@for( element of filteredElements; track element.mitgliedId ) {
	
									<div
										class="accRow"
										(click)="clickOnRow( element.mitgliedId )"
										[class.accRowActive]="expandedElementId == element.mitgliedId"
										[id]="'elementRow_' + element.mitgliedId"
									>
										<div class="accCell">
											{{ element.mitgliedsname }}
										</div>
									</div>
	
									@if( expandedElementId == element.mitgliedId ) {
	
										<div
											class="accDetail"
											[@accordeonMe]
										>
											<app-member-editor 
												[member]="element"
												[sections]="sections"
												[groups]="groups"
												[documentExchangeCategories]="documentExchangeCategories"
												(done)="sortElements()"
												[users]="canBeContact[element.mitgliedId]"
												[usernames]="usernames"
											/>
										</div>
	
									}
	
								}
	
							</div>
	
						}
	
					</div>

				</div>

			}

		</div>

	</div>

</div>